import createReducer from "../../createReducer";
import { hubspotTablesHandlers } from "../handlers";
import { IHubspotTablesState } from "../types";

export const hubspotTables: IHubspotTablesState = {
    isLoading: false,
    error: null,
    hubspotTablesData: null,
    success: false,
    message: "",
};
export default createReducer(hubspotTables, hubspotTablesHandlers);
